import React from 'react'
import { GridFilterCellProps } from '@progress/kendo-react-grid'

import { OptionsProps } from './types'

type CheckboxValue = boolean

type SelectFilterCellProps = {
  options?: OptionsProps
}

export const checkboxFilterCell =
  ({ options }: SelectFilterCellProps) =>
  (props: GridFilterCellProps): JSX.Element => <CheckboxFilterCell {...props} options={options} />

type SelectFilterCellComponentProps = {
  options?: OptionsProps
} & GridFilterCellProps

export const CheckboxFilterCell: React.FC<SelectFilterCellComponentProps> = (props) => {
  const operator = (value: CheckboxValue, checkboxValue: CheckboxValue) => {
    if (checkboxValue === value) {
      return true
    }
    return false
  }

  const operatorDefault = () => {
    return true
  }

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange({
      value: event.target.checked || false,
      operator: event.target.checked ? operator : operatorDefault,
      syntheticEvent: event,
    })
  }

  return (
    <input type='checkbox' checked={props.value} onChange={onChange} style={{ width: '100%' }} />
  )
}
